// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Mute as MutedSvg, Unmute as UnmutedSvg } from '../../../../assets/svg';
import { MUTE_LOCAL_STORAGE_NAME } from '../../../../constants/storage';
import { useLocalStorage } from '../../../../hooks';
import { type SoundInstance } from '../../../../types/sounds';
import SharedStyle from '../../styled-component/shared';

const playingAnimationKeyframes = keyframes`
  50% {
    transform: scale(1.25);
  }
`;

const soundButtonStyle = css`
  position: absolute;
  top: 0.8em;
  left: 0.8em;
  z-index: 1000;
  width: 3em;
  height: 3em;
  cursor: pointer;

  ${SharedStyle.ImageAsButtonsBehaviour};

  ${({ $isAnimated }) =>
    $isAnimated
      ? css`
          animation: ${playingAnimationKeyframes} 1000ms ease-in-out infinite;
        `
      : undefined}
`;

const MutedButton = styled(MutedSvg)`
  ${soundButtonStyle};
`;

const UnmutedButton = styled(UnmutedSvg)`
  ${soundButtonStyle};
`;

type KLSoundButtonProps = {
  sound: SoundInstance | null;
};

const KLSoundButton = ({ sound }: KLSoundButtonProps) => {
  const [isMuted, setMuted] = useLocalStorage(MUTE_LOCAL_STORAGE_NAME, false);
  const SoundButton = useMemo(() => (isMuted ? MutedButton : UnmutedButton), [isMuted]);

  useEffect(() => {
    if (sound) {
      if (isMuted) {
        sound.stop();
      } else {
        sound.play();
      }
    }
  }, [sound, isMuted]);

  return <SoundButton onClick={() => setMuted(!isMuted)} $isAnimated={!isMuted} />;
};

export default KLSoundButton;
